(function (Drupal) {
  function getItemLabel() {
    const t =
      typeof Drupal !== "undefined" && typeof Drupal.t === "function"
        ? Drupal.t.bind(Drupal)
        : (s) => s;
    // "fr-FR" → "fr"
    switch (document.documentElement.lang.split("-")[0].toLowerCase()) {
      case "fr":
        return t("Champ requis");
      case "de":
        return t("Pflichtfeld");
      case "es":
        return t("Campo requerido");
      case "it":
        return t("Campo obbligatorio");
      default:
        return t("Required field");
    }
  }

  /**
   * Forms to refresh for this attach: prefer `context` so AJAX fragments
   * do not rescan every form on the page.
   *
   * @param {Document|Element} context
   * @return {HTMLFormElement[]}
   */
  function formsInContext(context) {
    const root =
      context instanceof Document
        ? context
        : context instanceof Element
          ? context
          : document;
    const selector = 'form:not([id^="views-exposed-form"])';
    const found = new Set();

    if (root instanceof Element && root.matches(selector)) {
      found.add(root);
    }
    root.querySelectorAll(selector).forEach((form) => found.add(form));

    // AJAX often replaces fields inside an existing form — refresh that form.
    if (root instanceof Element && !found.size) {
      const closest = root.closest(selector);
      if (closest) {
        found.add(closest);
      }
    }

    return [...found];
  }

  /**
   * Build the legend with DOM APIs only (no innerHTML).
   *
   * @return {HTMLElement}
   */
  function createLegend() {
    const legend = document.createElement("div");
    legend.className = "form-required-legend small text-xs mb-2";
    legend.style.flexGrow = "1";
    legend.style.display = "block";
    legend.style.gridColumn = "1 / -1";
    legend.textContent = `* ${getItemLabel()}`;
    return legend;
  }

  /**
   * @param {HTMLFormElement} form
   */
  function refreshRequiredLegend(form) {
    const inputs = form.querySelectorAll(
      "input:not([type=submit]):not([type=image]):not([type=hidden]),textarea[required],select"
    );
    let nbRequired = 0;
    let nbOptional = 0;
    inputs.forEach((input) => {
      if (input.hasAttribute("required")) {
        nbRequired++;
      } else {
        nbOptional++;
      }
    });

    const needRequiredMention = nbRequired && nbOptional;
    const existing = form.querySelector(":scope > .form-required-legend");

    if (needRequiredMention && !existing) {
      const legend = createLegend();
      // Défaut : placement historique en bas de formulaire. Les sites opt-in
      // du kit a11y (ssks_form_alter) posent data-ssks-required-legend="prepend"
      // pour placer la légende en haut, après l'error summary le cas échéant.
      // closest() : formulaire rendu dans un bloc, l'attribut est reporté
      // sur le wrapper du bloc.
      const preferPrepend =
        form
          .closest("[data-ssks-required-legend]")
          ?.getAttribute("data-ssks-required-legend") === "prepend";
      if (!preferPrepend) {
        form.appendChild(legend);
      } else {
        const summary = form.querySelector(
          ":scope > .ssks-form-error-summary"
        );
        if (summary) {
          summary.insertAdjacentElement("afterend", legend);
        } else {
          form.insertBefore(legend, form.firstChild);
        }
      }
    } else if (!needRequiredMention && existing) {
      existing.remove();
    }
  }

  Drupal.behaviors.formRequiredMention = {
    attach(context) {
      formsInContext(context).forEach(refreshRequiredLegend);
    },
  };
})(Drupal);
